import React, { useEffect, useMemo, useRef, useState } from "react";
import "./LearningProcess.css";
import img1 from "../../Assets/images/review 1.png";
import img2 from "../../Assets/images/review 2.png";
import img3 from "../../Assets/images/review 3.png";
import img4 from "../../Assets/images/review 4.png";
import { useTranslation } from "react-i18next";




const LearningProcess = () => {
  const scrollerRef = useRef(null);
  const itemRefs = useRef([]);
  const [active, setActive] = useState(0); // ✅ first item active by default

  const { t } = useTranslation();
  const steps = [
  {
    id: 1,
    title: t("steps_assess_title"),
    body: t("steps_assess_body"),
    icon: img1,
  },
  {
    id: 2,
    title: t("steps_learn_title"),
    body: t("steps_learn_body"),
    icon: img2,
  },
  {
    id: 3,
    title: t("steps_apply_title"),
    body: t("steps_apply_body"),
    icon: img3,
  },
  {
    id: 4,
    title: t("steps_progress_title"),
    body: t("steps_progress_body"),
    icon: img4,
  },
];
  // refs for each item
  itemRefs.current = useMemo(() => steps.map(() => React.createRef()), []);

  const centerTo = (idx) => {
    const node = itemRefs.current[idx]?.current;
    if (!node) return;

    node.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest", // prevents page from scrolling vertically
    });

    setActive(idx);
  };


  const goPrev = () => centerTo(Math.max(0, active - 1));
  const goNext = () => centerTo(Math.min(steps.length - 1, active + 1));

  // scroll first item into view initially
  // useEffect(() => {
  //   centerTo(0);
  // }, []);

  return (
    <section className="ts-section">
      <h2 className="ts-title">{t("proven_learning_process")}</h2>

      <div className="ts-wrapper" role="region" aria-label="Learning timeline">
        <button
          className="ts-nav ts-nav--left"
          onClick={goPrev}
          aria-label="Previous step"
        >
          ‹
        </button>

        <div className="ts-scroller" ref={scrollerRef}>
          <div className="ts-baseline" aria-hidden="true" />

          {steps.map((s, i) => (
            <div
              key={s.id ?? i}
              ref={itemRefs.current[i]}
              data-index={i}
              className={`ts-item ${i === active ? "is-active" : ""}`}
              onClick={() => centerTo(i)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") && centerTo(i)
              }
              aria-pressed={i === active}
              aria-label={`Step ${i + 1}: ${s.title.replace(/\n/g, " ")}`}
            >
              {/* Title and image above line */}
              <div className="ts-title-above">
                <img src={s.icon} alt={s.title} />
                {s.title}
              </div>

              {/* Number badge on line */}
              <div className="ts-badge-wrapper">
                <div className="ts-badge">{i + 1}</div>
                {i === active && <div className="ts-underline" />}
              </div>

              {/* Body below line - only when active */}
              {i === active && (
                <div className="ts-card">
                  <p>{s.body}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <button
          className="ts-nav ts-nav--right"
          onClick={goNext}
          aria-label="Next step"
        >
          ›
        </button>
      </div>
    </section>
  );
};

export default LearningProcess;
